import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getAssessmentsConfig = (): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			headerImage: '/svg/account-created.svg',
			title: 'Welcome to Assessments',
			subtitle:
				"Record your students' LLLL assessments data and get quick insights analysis based on them through dashboard charts and results tables.",
			button: {
				label: 'Show me around',
				type: 'full-width' as const
			},
			modalPosition: 'center' as const,
			hasBackdrop: true
		},
		{
			type: 'modal' as const,
			title: 'The assessment dashboard',
			subtitle:
				'The dashboard displays student results data for both Reading and Spelling assessments based on the LLLL’s benchmarking system. More details about the benchmarks can be found in the Assessment manuals.',
			image: '/img/ftux-assessment-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'modal' as const,
			title: 'Student results table',
			subtitle:
				'View detailed student reading and spelling assessment data across different assessment types and stages that have been entered in the online platform. Use the Results Type dropdown to explore different views and analyse student data.',
			image: '/img/ftux-assessment-2.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: true
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'modal' as const,
			title: 'Record digital assessments',
			subtitle:
				'Add assessment records with the ability to mark and record them directly here. Use our tools to quickly conduct, mark, record and edit digital assessments for all students.',
			image: '/img/ftux-assessment-3.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: true
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#add-assessment-record-button',
			subtitle: 'Click here to add new assessment records for the different Little Learners Assessments,',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#preselect-student-button',
			subtitle:
				'Alternatively you can click here to <strong>add or edit an assessment record</strong> for a particular student.',
			tooltipPlacement: 'right' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#dashboard-view-toggle',
			subtitle: 'Switch between the dashboard view or student results view here.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#class-and-assessment-period-filters',
			subtitle: 'Use the class or assessment period dropdowns to filter the student results table.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#table-view-toggle',
			subtitle:
				'Click here to access different results types and views including results for individual assessments and student progress information.',
			tooltipPlacement: 'right' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#assessment-export-button',
			subtitle:
				'Click here for additional options like exporting student data or moving assessment records from one period to another.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			}
		},
		{
			type: 'tooltip' as const,
			target: '#benchmark-filter',
			subtitle:
				'Filter students based on the LLLL benchmarks and identify any students that might need additional help.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			}
		},
		{
			type: 'tooltip' as const,
			target: '#assessment-resources-button',
			subtitle:
				'Click here to access the Little Learners assessment manuals for detailed information about how to conduct and assess using the Little Learners assessments.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			}
		}
	];

	const config: FtuxConfig = {
		id: 'assessments-ftux',
		name: 'Assessments Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
